function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import './map.scss';

const CustomG = ({
  mapElement,
  selectedCommunity,
  selectedPlace,
  mouseEnter,
  mouseLeave,
  getWinner,
  clickElement,
  showDots = false
}) => React.createElement("a", {
  href: mapElement.href,
  onClick: e => clickElement(e, mapElement)
}, React.createElement("g", {
  className: "".concat(mapElement.name, " ").concat(mapElement.ineId),
  "data-hover": selectedCommunity ? mapElement.parentId === selectedCommunity ? true : false : undefined,
  "data-selected": mapElement.parentId === selectedPlace.ineId || selectedPlace.ineId === mapElement.ineId,
  "data-sibiling": mapElement.parentId === selectedPlace.parentId,
  onMouseMove: e => mouseEnter(e, _objectSpread({}, mapElement, {}, getWinner(mapElement.ineId))),
  onMouseLeave: e => mouseLeave(e, _objectSpread({}, mapElement, {}, getWinner(mapElement.ineId)))
}, React.createElement("path", {
  key: mapElement.ineId,
  className: "mapElement ".concat(mapElement.name, " ").concat(mapElement.ineId),
  fill: !showDots ? getWinner(mapElement.ineId).partyColor : '#ccc',
  onClick: e => clickElement(e, mapElement),
  d: mapElement.svg
}), showDots && React.createElement("circle", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "st1",
  cx: mapElement.svgDots.x,
  cy: mapElement.svgDots.y,
  r: "5",
  fill: getWinner(mapElement.ineId).partyColor ? getWinner(mapElement.ineId).partyColor : '#444'
})));

const SvgMap = ({
  onClick,
  selected,
  mapElements,
  className,
  viewVoxStyle,
  whenChange,
  partiesWinners,
  currentCommunity,
  allRegions,
  selectedPlace,
  native,
  showDots = false,
  excludedGrandParentIds = []
}) => {
  const svgEl = useRef(null);
  const pathEl = useRef(null);

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        selectedItem = _useState2[0],
        setSelectedItem = _useState2[1];

  const _useState3 = useState(),
        _useState4 = _slicedToArray(_useState3, 2),
        selectedCommunity = _useState4[0],
        setSelectedCommunity = _useState4[1];

  const _useState5 = useState({
    x: null,
    y: null
  }),
        _useState6 = _slicedToArray(_useState5, 2),
        mousePos = _useState6[0],
        setMousePos = _useState6[1];

  const clickElement = (event, mapElement) => {
    if (!isExcluded(mapElement)) {
      onClick(mapElement, svgEl, event);
    }
  };

  const getWinner = ineId => {
    let win = {
      partyColor: '#EBEBEB'
    };

    if (partiesWinners) {
      win = partiesWinners.find(winner => winner.placeId === ineId) || {
        partyColor: '#EBEBEB'
      };
    }

    return win;
  };

  const mouseLeave = (e, mapElement) => {
    setSelectedCommunity('');
    setSelectedItem('');
    setMousePos({
      x: null,
      y: null
    });
  };

  const mouseEnter = (e, mapElement) => {
    if (!isExcluded(mapElement)) {
      if (allRegions && allRegions.length) {
        setSelectedItem(allRegions.find(region => region.ineId === mapElement.parentId).name);
      } else {
        setSelectedItem(mapElement.name);
      }

      setSelectedCommunity(mapElement.parentId);
      setMousePos({
        x: e.clientX,
        y: e.clientY
      });
    }
  };

  const isExcluded = mapElement => {
    return excludedGrandParentIds.some(data => {
      return data === mapElement.parentId;
    });
  };

  return React.createElement(Fragment, null, React.createElement("svg", {
    ref: svgEl,
    className: "map ".concat(className),
    viewBox: "0 0 511.8 393.8",
    xmlSpace: "preserve",
    "data-current": currentCommunity,
    "data-isselected": currentCommunity !== undefined
  }, React.createElement("g", {
    ref: pathEl,
    className: "svgContainer",
    style: viewVoxStyle,
    fill: "none"
  }, mapElements && mapElements.map(mapElement => {
    return React.createElement(CustomG, {
      key: "".concat(mapElement.ineId, "-").concat(mapElement.name),
      mapElement: mapElement,
      selectedCommunity: selectedCommunity,
      selectedPlace: selectedPlace,
      mouseEnter: mouseEnter,
      mouseLeave: mouseLeave,
      getWinner: getWinner,
      showDots: showDots,
      clickElement: clickElement
    });
  }))), mousePos.x && React.createElement("div", {
    className: "mapTooltip",
    style: {
      position: 'fixed',
      left: mousePos.x + 15,
      top: mousePos.y - 5
    }
  }, selectedItem));
};

SvgMap.propTypes = {
  onClick: PropTypes.func.isRequired,
  whenChange: PropTypes.func,
  selected: PropTypes.string,
  mapElements: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func
};
SvgMap.defaultProps = {
  selected: 'all',
  className: '',
  mapElements: []
};
export default SvgMap;